/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 4Monitoring API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query';

import type {
  AtualizarAlertaRequest,
  AtualizarAlertaResponseIResponse,
  AtualizarEmpresaRequest,
  AtualizarEmpresaResponseIResponse,
  AtualizarGrupoRequest,
  AtualizarGrupoResponseIResponse,
  AtualizarMonitorRequest,
  AtualizarMonitorResponseIResponse,
  AtualizarUsuarioRequest,
  AtualizarUsuarioResponseIResponse,
  AtualizarVariavelRequest,
  AtualizarVariavelResponseIResponse,
  CadastrarAlertaRequest,
  CadastrarAlertaResponseIResponse,
  CadastrarEmpresaRequest,
  CadastrarEmpresaResponseIResponse,
  CadastrarGrupoRequest,
  CadastrarGrupoResponseIResponse,
  CadastrarMonitorRequest,
  CadastrarMonitorResponseIResponse,
  CadastrarUsuarioRequest,
  CadastrarUsuarioResponseIResponse,
  CadastrarVariavelRequest,
  CadastrarVariavelResponseIResponse,
  DashboardResponseIEnumerableIResponse,
  DeleteAlertasDeletarParams,
  DeleteEmpresasDeletarParams,
  DeleteGruposDeletarParams,
  DeleteMonitoresDeletarParams,
  DeleteUsuariosDeletarParams,
  DeleteVariaveisDeletarParams,
  ExibirAlertaResponseIResponse,
  ExibirEmpresaResponseIResponse,
  ExibirGrupoResponseIResponse,
  ExibirMonitorResponseIResponse,
  ExibirTaskResponseIResponse,
  ExibirUsuarioResponseIResponse,
  GetAlertasAlertaParams,
  GetAlertasListarParams,
  GetEmpresasEmpresaParams,
  GetEmpresasListarParams,
  GetGruposGrupoParams,
  GetGruposListarParams,
  GetMonitoresListarParams,
  GetMonitoresMonitorParams,
  GetMonitoresTasksListarParams,
  GetMonitoresTasksTaskParams,
  GetUsuariosListarParams,
  GetUsuariosUsuarioParams,
  GetVariaveisListarParams,
  ListarAlertasResponseIEnumerableIResponse,
  ListarEmpresasResponseIEnumerableIResponse,
  ListarGruposResponseIEnumerableIResponse,
  ListarMonitoresResponseIEnumerableIResponse,
  ListarTasksResponseIEnumerableIResponse,
  ListarUsuariosResponseIEnumerableIResponse,
  ListarVariaveisResponseIEnumerableIResponse,
  LoginRequest,
  LoginResponseIResponse,
  ObjectIResponse,
  TokenUsuarioRequest,
  TokenUsuariosResponseIResponse
} from '../model';

import { customInstance } from './axios-instance';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const postAlertasCadastrar = (
    cadastrarAlertaRequest: CadastrarAlertaRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CadastrarAlertaResponseIResponse>(
      {url: `/alertas/cadastrar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cadastrarAlertaRequest, signal
    },
      options);
    }
  


export const getPostAlertasCadastrarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAlertasCadastrar>>, TError,{data: CadastrarAlertaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAlertasCadastrar>>, TError,{data: CadastrarAlertaRequest}, TContext> => {

const mutationKey = ['postAlertasCadastrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAlertasCadastrar>>, {data: CadastrarAlertaRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAlertasCadastrar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAlertasCadastrarMutationResult = NonNullable<Awaited<ReturnType<typeof postAlertasCadastrar>>>
    export type PostAlertasCadastrarMutationBody = CadastrarAlertaRequest
    export type PostAlertasCadastrarMutationError = unknown

    export const usePostAlertasCadastrar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAlertasCadastrar>>, TError,{data: CadastrarAlertaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAlertasCadastrar>>,
        TError,
        {data: CadastrarAlertaRequest},
        TContext
      > => {

      const mutationOptions = getPostAlertasCadastrarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAlertasAtualizar = (
    atualizarAlertaRequest: AtualizarAlertaRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AtualizarAlertaResponseIResponse>(
      {url: `/alertas/atualizar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: atualizarAlertaRequest, signal
    },
      options);
    }
  


export const getPostAlertasAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAlertasAtualizar>>, TError,{data: AtualizarAlertaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAlertasAtualizar>>, TError,{data: AtualizarAlertaRequest}, TContext> => {

const mutationKey = ['postAlertasAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAlertasAtualizar>>, {data: AtualizarAlertaRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAlertasAtualizar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAlertasAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof postAlertasAtualizar>>>
    export type PostAlertasAtualizarMutationBody = AtualizarAlertaRequest
    export type PostAlertasAtualizarMutationError = unknown

    export const usePostAlertasAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAlertasAtualizar>>, TError,{data: AtualizarAlertaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAlertasAtualizar>>,
        TError,
        {data: AtualizarAlertaRequest},
        TContext
      > => {

      const mutationOptions = getPostAlertasAtualizarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAlertasDeletar = (
    params?: DeleteAlertasDeletarParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ObjectIResponse>(
      {url: `/alertas/deletar`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteAlertasDeletarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAlertasDeletar>>, TError,{params?: DeleteAlertasDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAlertasDeletar>>, TError,{params?: DeleteAlertasDeletarParams}, TContext> => {

const mutationKey = ['deleteAlertasDeletar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAlertasDeletar>>, {params?: DeleteAlertasDeletarParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAlertasDeletar(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAlertasDeletarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAlertasDeletar>>>
    
    export type DeleteAlertasDeletarMutationError = unknown

    export const useDeleteAlertasDeletar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAlertasDeletar>>, TError,{params?: DeleteAlertasDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAlertasDeletar>>,
        TError,
        {params?: DeleteAlertasDeletarParams},
        TContext
      > => {

      const mutationOptions = getDeleteAlertasDeletarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAlertasAlerta = (
    params?: GetAlertasAlertaParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ExibirAlertaResponseIResponse>(
      {url: `/alertas/alerta`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAlertasAlertaQueryKey = (params?: GetAlertasAlertaParams,) => {
    return [
    `/alertas/alerta`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAlertasAlertaQueryOptions = <TData = Awaited<ReturnType<typeof getAlertasAlerta>>, TError = unknown>(params?: GetAlertasAlertaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAlertasAlerta>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlertasAlertaQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlertasAlerta>>> = ({ signal }) => getAlertasAlerta(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlertasAlerta>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAlertasAlertaQueryResult = NonNullable<Awaited<ReturnType<typeof getAlertasAlerta>>>
export type GetAlertasAlertaQueryError = unknown



export function useGetAlertasAlerta<TData = Awaited<ReturnType<typeof getAlertasAlerta>>, TError = unknown>(
 params?: GetAlertasAlertaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAlertasAlerta>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAlertasAlertaQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAlertasListar = (
    params?: GetAlertasListarParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ListarAlertasResponseIEnumerableIResponse>(
      {url: `/alertas/listar`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAlertasListarQueryKey = (params?: GetAlertasListarParams,) => {
    return [
    `/alertas/listar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAlertasListarQueryOptions = <TData = Awaited<ReturnType<typeof getAlertasListar>>, TError = unknown>(params?: GetAlertasListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAlertasListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlertasListarQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlertasListar>>> = ({ signal }) => getAlertasListar(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlertasListar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAlertasListarQueryResult = NonNullable<Awaited<ReturnType<typeof getAlertasListar>>>
export type GetAlertasListarQueryError = unknown



export function useGetAlertasListar<TData = Awaited<ReturnType<typeof getAlertasListar>>, TError = unknown>(
 params?: GetAlertasListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAlertasListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAlertasListarQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getDashboard = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DashboardResponseIEnumerableIResponse>(
      {url: `/dashboard`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDashboardQueryKey = () => {
    return [
    `/dashboard`
    ] as const;
    }

    
export const getGetDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getDashboard>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboard>>> = ({ signal }) => getDashboard(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboard>>>
export type GetDashboardQueryError = unknown



export function useGetDashboard<TData = Awaited<ReturnType<typeof getDashboard>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const postEmpresasCadastrar = (
    cadastrarEmpresaRequest: CadastrarEmpresaRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CadastrarEmpresaResponseIResponse>(
      {url: `/empresas/cadastrar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cadastrarEmpresaRequest, signal
    },
      options);
    }
  


export const getPostEmpresasCadastrarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmpresasCadastrar>>, TError,{data: CadastrarEmpresaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmpresasCadastrar>>, TError,{data: CadastrarEmpresaRequest}, TContext> => {

const mutationKey = ['postEmpresasCadastrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmpresasCadastrar>>, {data: CadastrarEmpresaRequest}> = (props) => {
          const {data} = props ?? {};

          return  postEmpresasCadastrar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmpresasCadastrarMutationResult = NonNullable<Awaited<ReturnType<typeof postEmpresasCadastrar>>>
    export type PostEmpresasCadastrarMutationBody = CadastrarEmpresaRequest
    export type PostEmpresasCadastrarMutationError = unknown

    export const usePostEmpresasCadastrar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmpresasCadastrar>>, TError,{data: CadastrarEmpresaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postEmpresasCadastrar>>,
        TError,
        {data: CadastrarEmpresaRequest},
        TContext
      > => {

      const mutationOptions = getPostEmpresasCadastrarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postEmpresasAtualizar = (
    atualizarEmpresaRequest: AtualizarEmpresaRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AtualizarEmpresaResponseIResponse>(
      {url: `/empresas/atualizar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: atualizarEmpresaRequest, signal
    },
      options);
    }
  


export const getPostEmpresasAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmpresasAtualizar>>, TError,{data: AtualizarEmpresaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmpresasAtualizar>>, TError,{data: AtualizarEmpresaRequest}, TContext> => {

const mutationKey = ['postEmpresasAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmpresasAtualizar>>, {data: AtualizarEmpresaRequest}> = (props) => {
          const {data} = props ?? {};

          return  postEmpresasAtualizar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmpresasAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof postEmpresasAtualizar>>>
    export type PostEmpresasAtualizarMutationBody = AtualizarEmpresaRequest
    export type PostEmpresasAtualizarMutationError = unknown

    export const usePostEmpresasAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmpresasAtualizar>>, TError,{data: AtualizarEmpresaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postEmpresasAtualizar>>,
        TError,
        {data: AtualizarEmpresaRequest},
        TContext
      > => {

      const mutationOptions = getPostEmpresasAtualizarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteEmpresasDeletar = (
    params?: DeleteEmpresasDeletarParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ObjectIResponse>(
      {url: `/empresas/deletar`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteEmpresasDeletarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmpresasDeletar>>, TError,{params?: DeleteEmpresasDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmpresasDeletar>>, TError,{params?: DeleteEmpresasDeletarParams}, TContext> => {

const mutationKey = ['deleteEmpresasDeletar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmpresasDeletar>>, {params?: DeleteEmpresasDeletarParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteEmpresasDeletar(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmpresasDeletarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmpresasDeletar>>>
    
    export type DeleteEmpresasDeletarMutationError = unknown

    export const useDeleteEmpresasDeletar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmpresasDeletar>>, TError,{params?: DeleteEmpresasDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmpresasDeletar>>,
        TError,
        {params?: DeleteEmpresasDeletarParams},
        TContext
      > => {

      const mutationOptions = getDeleteEmpresasDeletarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getEmpresasEmpresa = (
    params?: GetEmpresasEmpresaParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ExibirEmpresaResponseIResponse>(
      {url: `/empresas/empresa`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetEmpresasEmpresaQueryKey = (params?: GetEmpresasEmpresaParams,) => {
    return [
    `/empresas/empresa`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmpresasEmpresaQueryOptions = <TData = Awaited<ReturnType<typeof getEmpresasEmpresa>>, TError = unknown>(params?: GetEmpresasEmpresaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmpresasEmpresa>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmpresasEmpresaQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmpresasEmpresa>>> = ({ signal }) => getEmpresasEmpresa(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmpresasEmpresa>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmpresasEmpresaQueryResult = NonNullable<Awaited<ReturnType<typeof getEmpresasEmpresa>>>
export type GetEmpresasEmpresaQueryError = unknown



export function useGetEmpresasEmpresa<TData = Awaited<ReturnType<typeof getEmpresasEmpresa>>, TError = unknown>(
 params?: GetEmpresasEmpresaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmpresasEmpresa>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmpresasEmpresaQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getEmpresasListar = (
    params?: GetEmpresasListarParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ListarEmpresasResponseIEnumerableIResponse>(
      {url: `/empresas/listar`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetEmpresasListarQueryKey = (params?: GetEmpresasListarParams,) => {
    return [
    `/empresas/listar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmpresasListarQueryOptions = <TData = Awaited<ReturnType<typeof getEmpresasListar>>, TError = unknown>(params?: GetEmpresasListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmpresasListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmpresasListarQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmpresasListar>>> = ({ signal }) => getEmpresasListar(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmpresasListar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmpresasListarQueryResult = NonNullable<Awaited<ReturnType<typeof getEmpresasListar>>>
export type GetEmpresasListarQueryError = unknown



export function useGetEmpresasListar<TData = Awaited<ReturnType<typeof getEmpresasListar>>, TError = unknown>(
 params?: GetEmpresasListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmpresasListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmpresasListarQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const postGruposCadastrar = (
    cadastrarGrupoRequest: CadastrarGrupoRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CadastrarGrupoResponseIResponse>(
      {url: `/grupos/cadastrar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cadastrarGrupoRequest, signal
    },
      options);
    }
  


export const getPostGruposCadastrarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGruposCadastrar>>, TError,{data: CadastrarGrupoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postGruposCadastrar>>, TError,{data: CadastrarGrupoRequest}, TContext> => {

const mutationKey = ['postGruposCadastrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGruposCadastrar>>, {data: CadastrarGrupoRequest}> = (props) => {
          const {data} = props ?? {};

          return  postGruposCadastrar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGruposCadastrarMutationResult = NonNullable<Awaited<ReturnType<typeof postGruposCadastrar>>>
    export type PostGruposCadastrarMutationBody = CadastrarGrupoRequest
    export type PostGruposCadastrarMutationError = unknown

    export const usePostGruposCadastrar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGruposCadastrar>>, TError,{data: CadastrarGrupoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postGruposCadastrar>>,
        TError,
        {data: CadastrarGrupoRequest},
        TContext
      > => {

      const mutationOptions = getPostGruposCadastrarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postGruposAtualizar = (
    atualizarGrupoRequest: AtualizarGrupoRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AtualizarGrupoResponseIResponse>(
      {url: `/grupos/atualizar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: atualizarGrupoRequest, signal
    },
      options);
    }
  


export const getPostGruposAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGruposAtualizar>>, TError,{data: AtualizarGrupoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postGruposAtualizar>>, TError,{data: AtualizarGrupoRequest}, TContext> => {

const mutationKey = ['postGruposAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGruposAtualizar>>, {data: AtualizarGrupoRequest}> = (props) => {
          const {data} = props ?? {};

          return  postGruposAtualizar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGruposAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof postGruposAtualizar>>>
    export type PostGruposAtualizarMutationBody = AtualizarGrupoRequest
    export type PostGruposAtualizarMutationError = unknown

    export const usePostGruposAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGruposAtualizar>>, TError,{data: AtualizarGrupoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postGruposAtualizar>>,
        TError,
        {data: AtualizarGrupoRequest},
        TContext
      > => {

      const mutationOptions = getPostGruposAtualizarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteGruposDeletar = (
    params?: DeleteGruposDeletarParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ObjectIResponse>(
      {url: `/grupos/deletar`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteGruposDeletarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGruposDeletar>>, TError,{params?: DeleteGruposDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGruposDeletar>>, TError,{params?: DeleteGruposDeletarParams}, TContext> => {

const mutationKey = ['deleteGruposDeletar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGruposDeletar>>, {params?: DeleteGruposDeletarParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteGruposDeletar(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGruposDeletarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGruposDeletar>>>
    
    export type DeleteGruposDeletarMutationError = unknown

    export const useDeleteGruposDeletar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGruposDeletar>>, TError,{params?: DeleteGruposDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteGruposDeletar>>,
        TError,
        {params?: DeleteGruposDeletarParams},
        TContext
      > => {

      const mutationOptions = getDeleteGruposDeletarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getGruposGrupo = (
    params?: GetGruposGrupoParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ExibirGrupoResponseIResponse>(
      {url: `/grupos/grupo`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetGruposGrupoQueryKey = (params?: GetGruposGrupoParams,) => {
    return [
    `/grupos/grupo`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetGruposGrupoQueryOptions = <TData = Awaited<ReturnType<typeof getGruposGrupo>>, TError = unknown>(params?: GetGruposGrupoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGruposGrupo>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGruposGrupoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGruposGrupo>>> = ({ signal }) => getGruposGrupo(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGruposGrupo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGruposGrupoQueryResult = NonNullable<Awaited<ReturnType<typeof getGruposGrupo>>>
export type GetGruposGrupoQueryError = unknown



export function useGetGruposGrupo<TData = Awaited<ReturnType<typeof getGruposGrupo>>, TError = unknown>(
 params?: GetGruposGrupoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGruposGrupo>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGruposGrupoQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getGruposListar = (
    params?: GetGruposListarParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ListarGruposResponseIEnumerableIResponse>(
      {url: `/grupos/listar`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetGruposListarQueryKey = (params?: GetGruposListarParams,) => {
    return [
    `/grupos/listar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetGruposListarQueryOptions = <TData = Awaited<ReturnType<typeof getGruposListar>>, TError = unknown>(params?: GetGruposListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGruposListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGruposListarQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGruposListar>>> = ({ signal }) => getGruposListar(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGruposListar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGruposListarQueryResult = NonNullable<Awaited<ReturnType<typeof getGruposListar>>>
export type GetGruposListarQueryError = unknown



export function useGetGruposListar<TData = Awaited<ReturnType<typeof getGruposListar>>, TError = unknown>(
 params?: GetGruposListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGruposListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGruposListarQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const postMonitoresCadastrar = (
    cadastrarMonitorRequest: CadastrarMonitorRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CadastrarMonitorResponseIResponse>(
      {url: `/monitores/cadastrar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cadastrarMonitorRequest, signal
    },
      options);
    }
  


export const getPostMonitoresCadastrarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoresCadastrar>>, TError,{data: CadastrarMonitorRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMonitoresCadastrar>>, TError,{data: CadastrarMonitorRequest}, TContext> => {

const mutationKey = ['postMonitoresCadastrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMonitoresCadastrar>>, {data: CadastrarMonitorRequest}> = (props) => {
          const {data} = props ?? {};

          return  postMonitoresCadastrar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMonitoresCadastrarMutationResult = NonNullable<Awaited<ReturnType<typeof postMonitoresCadastrar>>>
    export type PostMonitoresCadastrarMutationBody = CadastrarMonitorRequest
    export type PostMonitoresCadastrarMutationError = unknown

    export const usePostMonitoresCadastrar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoresCadastrar>>, TError,{data: CadastrarMonitorRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postMonitoresCadastrar>>,
        TError,
        {data: CadastrarMonitorRequest},
        TContext
      > => {

      const mutationOptions = getPostMonitoresCadastrarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMonitoresAtualizar = (
    atualizarMonitorRequest: AtualizarMonitorRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AtualizarMonitorResponseIResponse>(
      {url: `/monitores/atualizar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: atualizarMonitorRequest, signal
    },
      options);
    }
  


export const getPostMonitoresAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoresAtualizar>>, TError,{data: AtualizarMonitorRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMonitoresAtualizar>>, TError,{data: AtualizarMonitorRequest}, TContext> => {

const mutationKey = ['postMonitoresAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMonitoresAtualizar>>, {data: AtualizarMonitorRequest}> = (props) => {
          const {data} = props ?? {};

          return  postMonitoresAtualizar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMonitoresAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof postMonitoresAtualizar>>>
    export type PostMonitoresAtualizarMutationBody = AtualizarMonitorRequest
    export type PostMonitoresAtualizarMutationError = unknown

    export const usePostMonitoresAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoresAtualizar>>, TError,{data: AtualizarMonitorRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postMonitoresAtualizar>>,
        TError,
        {data: AtualizarMonitorRequest},
        TContext
      > => {

      const mutationOptions = getPostMonitoresAtualizarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteMonitoresDeletar = (
    params?: DeleteMonitoresDeletarParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ObjectIResponse>(
      {url: `/monitores/deletar`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteMonitoresDeletarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMonitoresDeletar>>, TError,{params?: DeleteMonitoresDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMonitoresDeletar>>, TError,{params?: DeleteMonitoresDeletarParams}, TContext> => {

const mutationKey = ['deleteMonitoresDeletar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMonitoresDeletar>>, {params?: DeleteMonitoresDeletarParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteMonitoresDeletar(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMonitoresDeletarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMonitoresDeletar>>>
    
    export type DeleteMonitoresDeletarMutationError = unknown

    export const useDeleteMonitoresDeletar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMonitoresDeletar>>, TError,{params?: DeleteMonitoresDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMonitoresDeletar>>,
        TError,
        {params?: DeleteMonitoresDeletarParams},
        TContext
      > => {

      const mutationOptions = getDeleteMonitoresDeletarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMonitoresMonitor = (
    params?: GetMonitoresMonitorParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ExibirMonitorResponseIResponse>(
      {url: `/monitores/monitor`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMonitoresMonitorQueryKey = (params?: GetMonitoresMonitorParams,) => {
    return [
    `/monitores/monitor`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMonitoresMonitorQueryOptions = <TData = Awaited<ReturnType<typeof getMonitoresMonitor>>, TError = unknown>(params?: GetMonitoresMonitorParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMonitoresMonitor>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMonitoresMonitorQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMonitoresMonitor>>> = ({ signal }) => getMonitoresMonitor(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMonitoresMonitor>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMonitoresMonitorQueryResult = NonNullable<Awaited<ReturnType<typeof getMonitoresMonitor>>>
export type GetMonitoresMonitorQueryError = unknown



export function useGetMonitoresMonitor<TData = Awaited<ReturnType<typeof getMonitoresMonitor>>, TError = unknown>(
 params?: GetMonitoresMonitorParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMonitoresMonitor>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMonitoresMonitorQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getMonitoresListar = (
    params?: GetMonitoresListarParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ListarMonitoresResponseIEnumerableIResponse>(
      {url: `/monitores/listar`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMonitoresListarQueryKey = (params?: GetMonitoresListarParams,) => {
    return [
    `/monitores/listar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMonitoresListarQueryOptions = <TData = Awaited<ReturnType<typeof getMonitoresListar>>, TError = unknown>(params?: GetMonitoresListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMonitoresListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMonitoresListarQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMonitoresListar>>> = ({ signal }) => getMonitoresListar(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMonitoresListar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMonitoresListarQueryResult = NonNullable<Awaited<ReturnType<typeof getMonitoresListar>>>
export type GetMonitoresListarQueryError = unknown



export function useGetMonitoresListar<TData = Awaited<ReturnType<typeof getMonitoresListar>>, TError = unknown>(
 params?: GetMonitoresListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMonitoresListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMonitoresListarQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getMonitoresTasksListar = (
    params?: GetMonitoresTasksListarParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ListarTasksResponseIEnumerableIResponse>(
      {url: `/monitores/tasks/listar`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMonitoresTasksListarQueryKey = (params?: GetMonitoresTasksListarParams,) => {
    return [
    `/monitores/tasks/listar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMonitoresTasksListarQueryOptions = <TData = Awaited<ReturnType<typeof getMonitoresTasksListar>>, TError = unknown>(params?: GetMonitoresTasksListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMonitoresTasksListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMonitoresTasksListarQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMonitoresTasksListar>>> = ({ signal }) => getMonitoresTasksListar(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMonitoresTasksListar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMonitoresTasksListarQueryResult = NonNullable<Awaited<ReturnType<typeof getMonitoresTasksListar>>>
export type GetMonitoresTasksListarQueryError = unknown



export function useGetMonitoresTasksListar<TData = Awaited<ReturnType<typeof getMonitoresTasksListar>>, TError = unknown>(
 params?: GetMonitoresTasksListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMonitoresTasksListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMonitoresTasksListarQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getMonitoresTasksTask = (
    params?: GetMonitoresTasksTaskParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ExibirTaskResponseIResponse>(
      {url: `/monitores/tasks/task`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMonitoresTasksTaskQueryKey = (params?: GetMonitoresTasksTaskParams,) => {
    return [
    `/monitores/tasks/task`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMonitoresTasksTaskQueryOptions = <TData = Awaited<ReturnType<typeof getMonitoresTasksTask>>, TError = unknown>(params?: GetMonitoresTasksTaskParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMonitoresTasksTask>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMonitoresTasksTaskQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMonitoresTasksTask>>> = ({ signal }) => getMonitoresTasksTask(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMonitoresTasksTask>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMonitoresTasksTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getMonitoresTasksTask>>>
export type GetMonitoresTasksTaskQueryError = unknown



export function useGetMonitoresTasksTask<TData = Awaited<ReturnType<typeof getMonitoresTasksTask>>, TError = unknown>(
 params?: GetMonitoresTasksTaskParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMonitoresTasksTask>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMonitoresTasksTaskQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const postUsuariosCadastrar = (
    cadastrarUsuarioRequest: CadastrarUsuarioRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CadastrarUsuarioResponseIResponse>(
      {url: `/usuarios/cadastrar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cadastrarUsuarioRequest, signal
    },
      options);
    }
  


export const getPostUsuariosCadastrarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsuariosCadastrar>>, TError,{data: CadastrarUsuarioRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postUsuariosCadastrar>>, TError,{data: CadastrarUsuarioRequest}, TContext> => {

const mutationKey = ['postUsuariosCadastrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsuariosCadastrar>>, {data: CadastrarUsuarioRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUsuariosCadastrar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUsuariosCadastrarMutationResult = NonNullable<Awaited<ReturnType<typeof postUsuariosCadastrar>>>
    export type PostUsuariosCadastrarMutationBody = CadastrarUsuarioRequest
    export type PostUsuariosCadastrarMutationError = unknown

    export const usePostUsuariosCadastrar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsuariosCadastrar>>, TError,{data: CadastrarUsuarioRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUsuariosCadastrar>>,
        TError,
        {data: CadastrarUsuarioRequest},
        TContext
      > => {

      const mutationOptions = getPostUsuariosCadastrarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUsuariosAtualizar = (
    atualizarUsuarioRequest: AtualizarUsuarioRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AtualizarUsuarioResponseIResponse>(
      {url: `/usuarios/atualizar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: atualizarUsuarioRequest, signal
    },
      options);
    }
  


export const getPostUsuariosAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsuariosAtualizar>>, TError,{data: AtualizarUsuarioRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postUsuariosAtualizar>>, TError,{data: AtualizarUsuarioRequest}, TContext> => {

const mutationKey = ['postUsuariosAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsuariosAtualizar>>, {data: AtualizarUsuarioRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUsuariosAtualizar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUsuariosAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof postUsuariosAtualizar>>>
    export type PostUsuariosAtualizarMutationBody = AtualizarUsuarioRequest
    export type PostUsuariosAtualizarMutationError = unknown

    export const usePostUsuariosAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsuariosAtualizar>>, TError,{data: AtualizarUsuarioRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUsuariosAtualizar>>,
        TError,
        {data: AtualizarUsuarioRequest},
        TContext
      > => {

      const mutationOptions = getPostUsuariosAtualizarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteUsuariosDeletar = (
    params?: DeleteUsuariosDeletarParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ObjectIResponse>(
      {url: `/usuarios/deletar`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteUsuariosDeletarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsuariosDeletar>>, TError,{params?: DeleteUsuariosDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUsuariosDeletar>>, TError,{params?: DeleteUsuariosDeletarParams}, TContext> => {

const mutationKey = ['deleteUsuariosDeletar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUsuariosDeletar>>, {params?: DeleteUsuariosDeletarParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteUsuariosDeletar(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUsuariosDeletarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUsuariosDeletar>>>
    
    export type DeleteUsuariosDeletarMutationError = unknown

    export const useDeleteUsuariosDeletar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsuariosDeletar>>, TError,{params?: DeleteUsuariosDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUsuariosDeletar>>,
        TError,
        {params?: DeleteUsuariosDeletarParams},
        TContext
      > => {

      const mutationOptions = getDeleteUsuariosDeletarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUsuariosUsuario = (
    params?: GetUsuariosUsuarioParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ExibirUsuarioResponseIResponse>(
      {url: `/usuarios/usuario`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetUsuariosUsuarioQueryKey = (params?: GetUsuariosUsuarioParams,) => {
    return [
    `/usuarios/usuario`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUsuariosUsuarioQueryOptions = <TData = Awaited<ReturnType<typeof getUsuariosUsuario>>, TError = unknown>(params?: GetUsuariosUsuarioParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsuariosUsuario>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsuariosUsuarioQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsuariosUsuario>>> = ({ signal }) => getUsuariosUsuario(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsuariosUsuario>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUsuariosUsuarioQueryResult = NonNullable<Awaited<ReturnType<typeof getUsuariosUsuario>>>
export type GetUsuariosUsuarioQueryError = unknown



export function useGetUsuariosUsuario<TData = Awaited<ReturnType<typeof getUsuariosUsuario>>, TError = unknown>(
 params?: GetUsuariosUsuarioParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsuariosUsuario>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUsuariosUsuarioQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getUsuariosListar = (
    params?: GetUsuariosListarParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ListarUsuariosResponseIEnumerableIResponse>(
      {url: `/usuarios/listar`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetUsuariosListarQueryKey = (params?: GetUsuariosListarParams,) => {
    return [
    `/usuarios/listar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUsuariosListarQueryOptions = <TData = Awaited<ReturnType<typeof getUsuariosListar>>, TError = unknown>(params?: GetUsuariosListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsuariosListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsuariosListarQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsuariosListar>>> = ({ signal }) => getUsuariosListar(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsuariosListar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUsuariosListarQueryResult = NonNullable<Awaited<ReturnType<typeof getUsuariosListar>>>
export type GetUsuariosListarQueryError = unknown



export function useGetUsuariosListar<TData = Awaited<ReturnType<typeof getUsuariosListar>>, TError = unknown>(
 params?: GetUsuariosListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsuariosListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUsuariosListarQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const postUsuariosLogin = (
    loginRequest: LoginRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoginResponseIResponse>(
      {url: `/usuarios/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
      options);
    }
  


export const getPostUsuariosLoginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsuariosLogin>>, TError,{data: LoginRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postUsuariosLogin>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['postUsuariosLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsuariosLogin>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUsuariosLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUsuariosLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postUsuariosLogin>>>
    export type PostUsuariosLoginMutationBody = LoginRequest
    export type PostUsuariosLoginMutationError = unknown

    export const usePostUsuariosLogin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsuariosLogin>>, TError,{data: LoginRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUsuariosLogin>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = getPostUsuariosLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUsuariosToken = (
    tokenUsuarioRequest: TokenUsuarioRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TokenUsuariosResponseIResponse>(
      {url: `/usuarios/token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tokenUsuarioRequest, signal
    },
      options);
    }
  


export const getPostUsuariosTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsuariosToken>>, TError,{data: TokenUsuarioRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postUsuariosToken>>, TError,{data: TokenUsuarioRequest}, TContext> => {

const mutationKey = ['postUsuariosToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsuariosToken>>, {data: TokenUsuarioRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUsuariosToken(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUsuariosTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postUsuariosToken>>>
    export type PostUsuariosTokenMutationBody = TokenUsuarioRequest
    export type PostUsuariosTokenMutationError = unknown

    export const usePostUsuariosToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsuariosToken>>, TError,{data: TokenUsuarioRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUsuariosToken>>,
        TError,
        {data: TokenUsuarioRequest},
        TContext
      > => {

      const mutationOptions = getPostUsuariosTokenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postVariaveisCadastrar = (
    cadastrarVariavelRequest: CadastrarVariavelRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CadastrarVariavelResponseIResponse>(
      {url: `/variaveis/cadastrar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cadastrarVariavelRequest, signal
    },
      options);
    }
  


export const getPostVariaveisCadastrarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariaveisCadastrar>>, TError,{data: CadastrarVariavelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postVariaveisCadastrar>>, TError,{data: CadastrarVariavelRequest}, TContext> => {

const mutationKey = ['postVariaveisCadastrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVariaveisCadastrar>>, {data: CadastrarVariavelRequest}> = (props) => {
          const {data} = props ?? {};

          return  postVariaveisCadastrar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVariaveisCadastrarMutationResult = NonNullable<Awaited<ReturnType<typeof postVariaveisCadastrar>>>
    export type PostVariaveisCadastrarMutationBody = CadastrarVariavelRequest
    export type PostVariaveisCadastrarMutationError = unknown

    export const usePostVariaveisCadastrar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariaveisCadastrar>>, TError,{data: CadastrarVariavelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postVariaveisCadastrar>>,
        TError,
        {data: CadastrarVariavelRequest},
        TContext
      > => {

      const mutationOptions = getPostVariaveisCadastrarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postVariaveisAtualizar = (
    atualizarVariavelRequest: AtualizarVariavelRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AtualizarVariavelResponseIResponse>(
      {url: `/variaveis/atualizar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: atualizarVariavelRequest, signal
    },
      options);
    }
  


export const getPostVariaveisAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariaveisAtualizar>>, TError,{data: AtualizarVariavelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postVariaveisAtualizar>>, TError,{data: AtualizarVariavelRequest}, TContext> => {

const mutationKey = ['postVariaveisAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVariaveisAtualizar>>, {data: AtualizarVariavelRequest}> = (props) => {
          const {data} = props ?? {};

          return  postVariaveisAtualizar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVariaveisAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof postVariaveisAtualizar>>>
    export type PostVariaveisAtualizarMutationBody = AtualizarVariavelRequest
    export type PostVariaveisAtualizarMutationError = unknown

    export const usePostVariaveisAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariaveisAtualizar>>, TError,{data: AtualizarVariavelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postVariaveisAtualizar>>,
        TError,
        {data: AtualizarVariavelRequest},
        TContext
      > => {

      const mutationOptions = getPostVariaveisAtualizarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteVariaveisDeletar = (
    params?: DeleteVariaveisDeletarParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ObjectIResponse>(
      {url: `/variaveis/deletar`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteVariaveisDeletarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariaveisDeletar>>, TError,{params?: DeleteVariaveisDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVariaveisDeletar>>, TError,{params?: DeleteVariaveisDeletarParams}, TContext> => {

const mutationKey = ['deleteVariaveisDeletar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVariaveisDeletar>>, {params?: DeleteVariaveisDeletarParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteVariaveisDeletar(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVariaveisDeletarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVariaveisDeletar>>>
    
    export type DeleteVariaveisDeletarMutationError = unknown

    export const useDeleteVariaveisDeletar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariaveisDeletar>>, TError,{params?: DeleteVariaveisDeletarParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVariaveisDeletar>>,
        TError,
        {params?: DeleteVariaveisDeletarParams},
        TContext
      > => {

      const mutationOptions = getDeleteVariaveisDeletarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getVariaveisListar = (
    params?: GetVariaveisListarParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ListarVariaveisResponseIEnumerableIResponse>(
      {url: `/variaveis/listar`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetVariaveisListarQueryKey = (params?: GetVariaveisListarParams,) => {
    return [
    `/variaveis/listar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVariaveisListarQueryOptions = <TData = Awaited<ReturnType<typeof getVariaveisListar>>, TError = unknown>(params?: GetVariaveisListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariaveisListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariaveisListarQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariaveisListar>>> = ({ signal }) => getVariaveisListar(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariaveisListar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVariaveisListarQueryResult = NonNullable<Awaited<ReturnType<typeof getVariaveisListar>>>
export type GetVariaveisListarQueryError = unknown



export function useGetVariaveisListar<TData = Awaited<ReturnType<typeof getVariaveisListar>>, TError = unknown>(
 params?: GetVariaveisListarParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariaveisListar>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVariaveisListarQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
